import { Option } from 'app/types/interfaces/Option';
import { isString, get } from 'lodash';

type TransformToOptions = {
  valueKey?: string;
  labelKey?: string;
  transform?: (item: any) => Option;
};
export const transformToOptions = (data, options: TransformToOptions = {}) => {
  if (Array.isArray(data)) {
    return data.map((item) => {
      if (isString(item)) {
        return {
          label: item,
          value: item
        };
      }
      const { valueKey = 'id', labelKey = 'name', transform } = options;
      if (transform) {
        return transform(item);
      }
      return {
        label: get(item, labelKey, ''),
        value: get(item, valueKey, '')
      };
    });
  }
  return [];
};
